import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: {
    main: "#2D3436",
    sub: "#404040",
    deep: "#212121",
  },
  textColor: {
    main: "#FFFFFF",
    sub: "#707070",
  },
};

export const lightTheme: DefaultTheme = {
  bgColor: {
    main: "#EDEDED",
    sub: "#E0E0E0",
    deep: "#FAFAFA",
  },
  textColor: {
    main: "#333333",
    sub: "#707070",
  },
};
